export default "__VITE_ASSET__Cc6PW5G1__"